export default class FieldLabelHint {
  static toggleRequiredLabel(condition, element) {
    if (condition) {
      element.classList.remove('icon_label_pink');
      element.classList.add('icon_label_blue');
      element.textContent = 'OK';
    } else {
      element.classList.add('icon_label_pink');
      element.classList.remove('icon_label_blue');
      element.textContent = '必須';
    }
  }

  static toggleOptionalLabel(condition, element) {
    if (condition) {
      element.classList.remove('icon_label_gray');
      element.classList.add('icon_label_blue');
      element.textContent = 'OK';
    } else {
      element.classList.add('icon_label_gray');
      element.classList.remove('icon_label_blue');
      element.textContent = '任意';
    }
  }

  static toggleLpPageRequiredLabel(condition){
    if (this.isLpPageUrl()) {
      const iconLabel = $('#productCategoryLabel')[0].nextElementSibling;
      this.toggleRequiredLabel(condition, iconLabel);
    }
  }
  static isLpPageUrl() {
    return (location.pathname.match("pix/lp") !== null);
  }
}
